<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-ambulance`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M30 3a2 2 0 012 2v12h4.756a2 2 0 011.56.747l7.243 9.015A2 2 0 0146 28.014V37a2 2 0 01-2 2h-2V28.718L35.798 21H32v8h-4V7H6v28h1.528a6 6 0 11-1.524 4.225L6 39H4a2 2 0 01-2-2V5a2 2 0 012-2h26zm2 30a6 6 0 11-5.996 6.225L26 39h-4v-4h5.528A5.985 5.985 0 0132 33zm-22 6a2 2 0 114 0 2 2 0 01-4 0zm22-2a2 2 0 100 4 2 2 0 000-4zM19 15a1 1 0 00-1-1h-2a1 1 0 00-1 1v4h-4a1 1 0 00-1 1v2a1 1 0 001 1h4v4a1 1 0 001 1h2a1 1 0 001-1v-4h4a1 1 0 001-1v-2a1 1 0 00-1-1h-4v-4z"/></svg>
</template>
<script>

export default {
  name: 'IconAmbulance',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
